export default __webpack_public_path__ + "static/media/4564.457049b8.png";